import Icon from '@/components/snippets/icon/icon'
import { formatMoney } from '@/components/helpers/currency-formatter'
import { PRICE_FILTER_FIELD } from './FilterUtils'
import { globalState } from '@/components/helpers/utils'
import { isSizeFilter, formatUniversalSizeValue } from './SizeFilterUtils'

export function FilterSelected({ activeFilters, onRemove }) {
  if (!activeFilters || activeFilters.size === 0) return null

  const formatFilterValue = (filter) => {
    const [field, value] = filter.split(':')

    if (field === PRICE_FILTER_FIELD) {
      const [min, max] = value.split('<->')
      const formatMin = parseFloat(min) % 1 === 0 ? globalState.shopify.moneyFormat.replace('amount', 'amount_no_decimals') : globalState.shopify.moneyFormat
      const formatMax = parseFloat(max) % 1 === 0 ? globalState.shopify.moneyFormat.replace('amount', 'amount_no_decimals') : globalState.shopify.moneyFormat
      return `${formatMoney(parseFloat(min) * 100, formatMin)} - ${formatMoney(parseFloat(max) * 100, formatMax)}`
    }

    if (isSizeFilter(field, value)) {
      return formatUniversalSizeValue(value)
    }

    return value
  }

  return (
    <div class="flex flex-wrap gap-0.5 px-margin lg:px-1.5 py-1.5 border-b border-neutral-light">
      {[...activeFilters].map((filter) => {
        return (
          <button class="shrink-0 flex gap-x-0.5 items-center justify-center text-xs size-fit px-1 py-0.5 rounded-badge bg-neutral-light hover:opacity-50 transition-all" onClick={() => onRemove(filter)} aria-label={`Remove ${formatFilterValue(filter)} filter`}>
            {formatFilterValue(filter)}
            <div className="flex size-[9px] children:size-full">
              <Icon id="close" />
            </div>
          </button>
        )
      })}
    </div>
  )
}
